import ListBuildings from './buildings/ListBuildings.vue'
import CreateBuilding from './buildings/CreateBuilding.vue'
import EditBuilding from './buildings/Editbuilding.vue'
import { routers as EditBuildingChildrenRouters } from './buildings/EditBuilding'
import AssignBuildingToUser from './buildings/AssignBuildingToUser.vue'
let routers = [
  {
    name: 'list-buildings',
    path: 'list-buildings',
    component: ListBuildings
  },
  {
    name: 'edit-building',
    path: 'edit-building/:buildingId',
    component: EditBuilding,
    children : EditBuildingChildrenRouters,
    redirect: {
      name: 'edit-building-access-code'
    }
  },
  {
    name: 'assign-building-to-user',
    path: 'assign-building-to-user/:buildingId',
    component: AssignBuildingToUser
  }

]

export { routers }